import { Component, OnInit,Input  } from '@angular/core';

@Component({
  selector: 'app-category-grid',
  templateUrl: './category-grid.component.html',
  styleUrls: ['./category-grid.component.scss']
})
export class CategoryGridComponent {
  // Input array: each item should have image, subheading, heading, link
  @Input() items: Array<{
    image: string;
    subheading: string;
    heading: string;
    link: string;
  }> = [];
}
